/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import ComplementaryServices from 'services/complementary_services';

import { ServicesSubscriptionState, ServicesSubscriptionTypes } from './types';

const INITIAL_STATE: ServicesSubscriptionState = {
  servicesSubscriptions: {
    Documents: {
      current_signature: false,
      has_any_signature: false,
      in_trial_period: 0,
      status_message: '',
      show_accept: false,
      service_paralyzed: false,
    },
    Monitoring: {
      current_signature: false,
      has_any_signature: false,
      in_trial_period: 0,
      status_message: '',
      show_accept: false,
      service_paralyzed: false,
    },
  },
  request: {
    loading: false,
    loaded: false,
    error: false,
  },
};

const reducer: Reducer<ServicesSubscriptionState> = (
  state = INITIAL_STATE,
  { type, result, complementary_service_id },
) => {
  return produce(state, (draft) => {
    const serviceName = ComplementaryServices.find(
      (complementaryService) => complementaryService.id === complementary_service_id,
    )?.name;
    switch (type) {
      case ServicesSubscriptionTypes.GET_SERVICE_SUBSCRIPTION_STATUS_REQUEST:
        draft.request = { ...INITIAL_STATE.request, loading: false };
        break;

      case ServicesSubscriptionTypes.GET_SERVICE_SUBSCRIPTION_STATUS_SUCCESS:
        if (serviceName) draft.servicesSubscriptions[serviceName] = result.data;
        draft.request = { ...INITIAL_STATE.request, loaded: false };
        break;

      case ServicesSubscriptionTypes.GET_SERVICE_SUBSCRIPTION_STATUS_FAILURE:
        draft.request = { ...INITIAL_STATE.request, error: false };
        break;

      default:
    }
  });
};

export default reducer;
